import { Component, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Inject } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray, FormBuilder, ValidatorFn } from '@angular/forms';

import { GlobalService } from '../../../services/global.service';
import { SnackBarService } from '../../../shared/snackbar/snackbar.service';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.css']
})
export class SupportComponent implements OnInit {
  //advisor;
  supportForm: FormGroup;

  constructor(@Inject(MAT_DIALOG_DATA) data, private dialogRef: MatDialogRef<SupportComponent>, private globalService: GlobalService, private snackBarService: SnackBarService, private formBuilder: FormBuilder) {
    //this.advisor.ID = localStorage.getItem('selectedAdvisorID');
    //this.advisor.OrganizationID = localStorage.getItem('orgID');
  }

  ngOnInit() {
    this.supportForm = this.formBuilder.group({
      subject: ['', Validators.required],
      message: ['', Validators.required]
    });
  }

  submit() {
    this.snackBarService.add('Thank you for submitting a ticket. A support specialist will be in touch.', 0);
    
    // Save to our local system first
    this.globalService.addSupportTicketLocal(this.supportForm.value.subject, this.supportForm.value.message);

    this.close();

    var SupportModel = {
      AdvisorID: Number(localStorage.getItem('selectedAdvisorID')),
      OrgID: Number(localStorage.getItem('orgID')),
      Subject: this.supportForm.value.subject,
      Message: this.supportForm.value.message,
    }

    this.globalService.createSupportTicket(SupportModel)
      .subscribe(
        data => { });
        //,error => this.error = <any>error);
  }

  close() {
    this.dialogRef.close();
  }
}
